import { IconWrapper } from '../runtime';
export default IconWrapper('code-block', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.00004 1.99969H4.50004C3.67161 1.99969 3.00004 2.67127 3.00004 3.49969V6.79659C3.00004 6.91926 2.92535 7.02957 2.81145 7.07513L1.1964 7.72115C0.944952 7.82173 0.944951 8.17766 1.1964 8.27824L2.81145 8.92426C2.92535 8.96982 3.00004 9.08013 3.00004 9.2028V12.4997C3.00004 13.3281 3.67161 13.9997 4.50004 13.9997H6.00004M10 13.9997H11.5C12.3285 13.9997 13 13.3281 13 12.4997V9.2028C13 9.08013 13.0747 8.96982 13.1886 8.92426L14.8037 8.27824C15.0551 8.17766 15.0551 7.82173 14.8037 7.72115L13.1886 7.07513C13.0747 7.02957 13 6.91926 13 6.79659V3.49969C13 2.67127 12.3285 1.99969 11.5 1.99969H10",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});